import { useApp } from "@/context/AppContext";
import { IMAGES } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import { Section } from "@/components/Section";
import { Smartphone, Apple, Play, Wifi, Bell, ShieldCheck } from "lucide-react";

const FEATURE_ICONS = [Wifi, Bell, ShieldCheck];

export default function Download() {
  const { t } = useApp();
  const d = t.downloadP;
  return (
    <div>
      <Section sid="download.hero" name="App Hero" className="relative overflow-hidden min-h-[70vh] flex items-center grain">
        <img src={IMAGES.building} alt="app" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#014845] via-[#017471]/90 to-[#014845]" />
        <div className="relative oj-container py-20 text-center">
          <Reveal>
            <div className="grid place-items-center w-20 h-20 rounded-3xl bg-gradient-to-br from-amber-400 to-amber-600 mx-auto mb-6 shadow-2xl shadow-amber-900/40"><Smartphone className="w-10 h-10 text-teal-950" /></div>
            <div className="oj-eyebrow justify-center mb-3">{d.eyebrow}</div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight max-w-3xl mx-auto leading-tight">{d.title}</h1>
            <p className="mt-6 text-lg text-slate-600 max-w-2xl mx-auto leading-relaxed">{d.sub}</p>
            <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
              <a href="#" className="oj-btn-gold !px-7 !py-4" data-testid="download-play-store"><Play className="w-5 h-5" fill="currentColor" /> <div className="text-left leading-tight"><div className="text-[10px] font-normal opacity-80">{d.getOn}</div><div>Google Play</div></div></a>
              <a href="#" className="oj-btn-ghost !px-7 !py-4" data-testid="download-app-store"><Apple className="w-5 h-5" /> <div className="text-left leading-tight"><div className="text-[10px] font-normal opacity-80">{d.dlOn}</div><div>App Store</div></div></a>
            </div>
            <p className="mt-4 text-xs text-slate-500 font-mono">Android TWA • iOS Universal Links • PWA Ready (Target SDK 34)</p>
          </Reveal>
        </div>
      </Section>

      <Section sid="download.features" name="App Features" className="oj-section">
        <div className="oj-container grid grid-cols-1 md:grid-cols-3 gap-6">
          {d.features.map(([title, desc], i) => {
            const Icon = FEATURE_ICONS[i];
            return (
              <Reveal key={title} delay={i * 0.1}>
                <div className="oj-card p-7 h-full text-center">
                  <div className="grid place-items-center w-12 h-12 rounded-xl bg-teal-500/15 border border-cyan-400/30 mx-auto mb-4"><Icon className="w-6 h-6 text-teal-600" /></div>
                  <h4 className="font-bold text-white mb-2">{title}</h4>
                  <p className="text-sm text-slate-600 leading-relaxed">{desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </Section>
    </div>
  );
}
